const headRows = {
  file: 'File',
  modifiedAt: 'Modified in',
  size: 'Size',
  download: 'Download',
  description: 'Description'
};

export default headRows;
